import gql from 'graphql-tag'

export const newTracker = gql`
  mutation newTracker(
    $name: String!
    $category: String!
    $isStared: Boolean!
    $isDuration: Boolean!
    $color: String
    $isPublic: Boolean
    $type: String
    $userId: ID!
  ) {
    createTracker(
      name: $name
      category: $category
      isStared: $isStared
      isDuration: $isDuration
      color: $color
      isPublic: $isPublic
      type: $type
      userId: $userId
    ) {
      id
    }
  }
`

export const updateCurrentTracker = gql`
  mutation updateCurrentTracker(
    $currentId: String
    $currentName: String
    $id: ID!
    $userId: ID!
  ) {
    updateTracker(
      currentId: $currentId
      currentName: $currentName
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const updateTracker = gql`
  mutation updateTracker(
    $name: String!
    $category: String!
    $isStared: Boolean!
    $isDuration: Boolean!
    $color: String
    $isPublic: Boolean
    $type: String
    $id: ID!
    $userId: ID!
  ) {
    updateTracker(
      name: $name
      category: $category
      isStared: $isStared
      isDuration: $isDuration
      color: $color
      isPublic: $isPublic
      type: $type
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const deleteTracker = gql`
  mutation deleteTracker($id: ID!) {
    deleteTracker(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/tracker.js